import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ArtistAvatar } from '../components/artist-avatar.component';
import { ArtistName } from '../components/artist-name.component';
import { AppContext } from '../stores/app.store';

export const ArtistsPage = observer(() => {

    const { auctionStore } = useContext(AppContext);

    const artists = (auctionStore.artists) ? (
        <div className="col-12 col-xxl-8">
            <div className="w-100 px-5 pt-3 pb-5 my-5 bg-darker text-secondary text-avenir-re text-center">
                <div className="mx-5 text-300 text-light border-bottom border-secondary">
                    <ArtistName firstName="our" lastName="artists" />
                </div>
            </div>

            <div className="d-none w-75 ps-4 my-5">
                <p className="large-serif bg-darker text-muted p-2">
                    <FontAwesomeIcon style={{ marginLeft: '-42px' }} className="me-2 opacity-50" icon="quote-left" />
                    Imagination embraces the entire world, and all there ever will
                    be to know and understand
                    <FontAwesomeIcon className="ms-2 opacity-50" icon="quote-right" />
                </p>
                <br className="mb-5" />
            </div>

            <div className="d-flex justify-content-center flex-wrap overflow-hidden">
                {Object.values(auctionStore.artists).map((artist, i) => {
                    return (
                        <div key={i} className="col-3 mb-5">
                            <div className="px-2 pb-5">
                                <ArtistAvatar artist={artist} />
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    ) : (null);

    return (
        <div className="d-flex flex-column align-items-center mx-5">
            {artists}
            <div style={{ height: '5px', width: '100px' }} className="bg-light my-5"></div>
            <div className="py-3 px-5 bg-darker">
                <Link to="/become-an-artist" className="text-115 text-primary text-avenir-re">
                    INTERESTED IN BECOMING A PARTNER?
            </Link>
            </div>
        </div>
    )
});